module.exports = __webpack_public_path__ + "static/media/publication_5.e7957595.pdf";